import { Badge, Box, StyleProps } from "@chakra-ui/react";
import { DragEvent } from "react";

interface SignatureGroupProps {
    title: string,
    multipleSigners: boolean,
    isDragOver: boolean,
    sectionStyle: StyleProps,
    children: React.ReactNode,
    onDragOver: (e: DragEvent<HTMLDivElement>) => void,
    onDragLeave: (e: DragEvent<HTMLDivElement>)=> void,
    onDrop: (e: DragEvent<HTMLDivElement>) => void
}

export const SignatureGroup = (props: SignatureGroupProps) => {
    const { title, multipleSigners, isDragOver, sectionStyle, children , onDrop, onDragOver, onDragLeave } = props;

    return (
        <Box
            bg={sectionStyle.bg}
            boxShadow="md"
            borderRadius="xl"
            borderColor="blue.300"
            border={isDragOver ? "2px solid" : "1px white"}
            overflow="hidden"
            transition="all 0.2s"
            transform={isDragOver ? "scale(1.02)" : "scale(1)"}
            opacity={isDragOver ? "0.5" : "1"}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
        >
            {multipleSigners && (
                <Badge
                    display="inline-block"
                    bg="whiteAlpha.300"
                    borderRadius="full"
                    colorScheme="whiteAlpha"
                    color="white"
                    fontSize="xs"
                    fontWeight="bold"
                    px={3}
                    py={1}
                    m={3}
                >
                    {title}
                </Badge>
            )}
            {children}
        </Box>
  );
};